import { packValidateResults, required } from 'helpers/validators';

export const validate = (data: any) => {
  return packValidateResults([required(data, ['company_name', 'email', 'phone'])]);
};
